import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "../../utils/logging";

export default function RouteObserver() {
  const location = useLocation();

  useEffect(() => {
    (async () => {
      try {
        await trackPageView();
      } catch (error) {
        console.error("Error tracking page view:", error);
      }
    })();
  }, [location.pathname]);

  return null;
}